import { ReactNode } from "react";

interface ToolbarButtonProps {
  onMouseDown: () => void;
  active?: boolean;
  title: string;
  children: ReactNode;
}

export default function AppToolbarButton({ onMouseDown, active, title, children }: ToolbarButtonProps) {
    return (<button
        type="button"
        title={title}
        onMouseDown={(e) => {
            e.preventDefault();
            onMouseDown();
        }}
        className={`editor-tool-button ${active ? "editor-tool-button-active" : ""}`}
        >
        {children}
    </button>);
} 